import { useState, useEffect } from "react";
import { useQuery } from "@apollo/client";
import { LIST_VENUES } from "graphql/graph";

const useVenueData = (venueId) => {
  const [venue, setVenue] = useState(null);
  const [expandedAreas, setExpandedAreas] = useState({});

  const {
    data: listVenuesData,
    loading: listVenuesLoading,
    error: listVenuesError,
  } = useQuery(LIST_VENUES, {
    context: { clientName: "graph" },
    variables: { venueIds: [venueId] },
  });

  useEffect(() => {
    if (listVenuesData?.listVenues?.data?.length) {
      const singleVenue = listVenuesData.listVenues.data[0];
      setVenue(singleVenue);

      const initialExpandedAreas =
        singleVenue.Areas?.reduce((acc, area) => {
          acc[area.id] = true;
          return acc;
        }, {}) || {};

      setExpandedAreas(initialExpandedAreas);
    } else {
      setVenue(null);
      setExpandedAreas({});
    }
  }, [listVenuesData]);

  const totalCameras =
    venue?.Areas?.reduce((acc, area) => acc + (area.Machines?.length || 0), 0) || 0;

  const activeCameras =
    venue?.Areas?.reduce(
      (acc, area) => acc + (area.Machines?.filter((m) => m.machineStatus === 1)?.length || 0),
      0,
    ) || 0;

  const totalInferences =
    venue?.Areas?.reduce(
      (acc, area) => acc + (area.Machines?.filter((m) => m.machineInferenceStatus)?.length || 0),
      0,
    ) || 0;

  const overviewItems = [
    { value: totalCameras, label: "Cameras", icon: "cameras" },
    { value: activeCameras, label: "Active Cameras", icon: "venues" },
    { value: totalInferences, label: "Inferences", icon: "inferences" },
  ];

  return {
    venue,
    expandedAreas,
    setExpandedAreas,
    listVenuesLoading,
    listVenuesError,
    overviewItems,
  };
};

export default useVenueData;
